module.exports = __webpack_public_path__ + "static/media/chrome.18f74543.svg";